/**
 * External URLs used in the application
 */

// Terms and Conditions URL that will be utalised in TermsAndConditions.tsx and Settings.tsx
export const TERMS_AND_CONDITIONS_URL = 'https://www.lseg.com/content/dam/data-analytics/en_us/documents/support/workspace/lseg-adm-license-agreement.pdf';

// Microsoft Learn — Manage external access in Microsoft Teams (used by policy federation toggles)
export const MANAGE_EXTERNAL_ACCESS_URL =
  'https://learn.microsoft.com/en-us/microsoftteams/trusted-organizations-external-meetings-chat?tabs=organization-settings';
